import { useState } from "react";
import { TbCurrencyNaira } from "react-icons/tb";
import { LuEye, LuEyeOff } from "react-icons/lu";
import { FaPlus } from "react-icons/fa";
import { MdDownload } from "react-icons/md";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
// import usePostRequest from "@/hooks/usePostRequest";
import CurrencyInput from "react-currency-input-field";

import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import bg from "@/assets/pattern.png";
import { Link } from "react-router-dom";
import moment from "moment";
import { Loading } from "notiflix";
import axios from "axios";
import { Report } from "notiflix";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { Button } from "../ui/button";

const TotalBalanceBox = ({ isAgent }) => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.user);
  const [hidden, setHidden] = useState(false);
  const [addMoney, setAddMoney] = useState(false);

  const { loading, postRequest } = { loading: false, postRequest: () => {} };
  const [amount, setAmount] = useState(null);
  const hasAccount = user.acct_number && user.bank_name && user.account_name;

  const isSmallScreen = useMediaQuery({ query: "(max-width: 340px)" });

  const handleHide = () => {
    setHidden((prev) => !prev);
  };

  async function initializeTransaction(e) {
    e.preventDefault();
    const fData = new FormData();
    fData.append("amount", amount);
    const { onSuccess, data } = await postRequest(
      "/api/user/initialize-transaction",
      fData,
    );
    if (onSuccess) {
      window.open(data.authorization_url);
      setAmount(null);
      setAddMoney(false);
    }
  }

  async function requestAccount(e) {
    e.preventDefault();
  }

  const formatter = new Intl.NumberFormat("en-US");

  const [withdrawOpen, setWithdrawOpen] = useState(false);
  const [withdrawalAmount, setWithdrawalAmount] = useState(1000);

  let withdrawalDisplay = (
    <div>
      <p>
        Kindly confirm the details below before sending the withdrawal request
      </p>
      <div className="grid w-fit grid-cols-2 gap-2 py-2">
        <b>Account Name</b>
        <p>{user.withdrawal_account_name}</p>
        <b>Account Number</b>
        <p>{user.withdrawal_account_number}</p>
        <b>Bank Name</b>
        <p>{user.withdrawal_bank_name}</p>
      </div>
      <div>
        <label
          htmlFor="amount"
          className="text-sm text-black/80 dark:text-white"
        >
          Input Amount
        </label>
        <CurrencyInput
          value={withdrawalAmount}
          type="text"
          className="block w-full rounded-md border bg-white p-2 text-black outline-none dark:bg-gray-900 dark:text-white"
          onValueChange={(v) => setWithdrawalAmount(v)}
          prefix="₦"
        />
        <div className="text-xs text-orange-500">
          Minimum amount is ₦1,000 and the maximum is{" "}
          {formatter.format(user.commission)}
        </div>
      </div>
      <button
        className="mt-4 rounded-full bg-blue-500 px-4 py-2 text-white disabled:opacity-40"
        onClick={async () => {
          try {
            Loading.standard("Sending withdrawal request");
            const formData = new FormData();
            formData.append("amount", withdrawalAmount);
            const { data } = await axios.post(
              "/api/user/withdrawal-request",
              formData,
            );
            if (!data.err) {
              Report.success(
                "Request sent successfully",
                "We will credit you your commision as soon as possbile",
                "Ok",
                {
                  messageMaxLength: 132,
                },
              );
            } else {
              Report.failure("Error", data.err);
            }
          } catch (error) {
            console.log(error);
            toast.error(
              "Error sending withdrawal request, check your internet connection and try again later",
            );
          } finally {
            Loading.remove();
            setWithdrawOpen(false);
          }
        }}
        disabled={
          !withdrawalAmount ||
          withdrawalAmount > user.commission ||
          withdrawalAmount < 1000
        }
      >
        Send Request
      </button>
    </div>
  );

  if (user.commission < 1000) {
    withdrawalDisplay = (
      <div>
        <p>
          You need to have a balance of at least <b>₦1,000</b> to request for a
          withdrawal and Your current balance is{" "}
          <b className="text-red-600">₦{formatter.format(user.commission)}</b>
        </p>
      </div>
    );
  }

  if (
    user.last_withdrawal_request &&
    moment().diff(moment(user.last_withdrawal_request), "days") < 1
  ) {
    withdrawalDisplay = (
      <div>
        <p>You can only request for a withdrawal once every 24 hours</p>
        <span>
          You can request for a withdrawal at{" "}
          <b>
            {moment(user.last_withdrawal_request)
              .add(1, "days")
              .format("MMMM Do YYYY, h:mm:ss a")}
          </b>
        </span>
      </div>
    );
  }

  if (
    !user.withdrawal_account_name ||
    !user.withdrawal_account_number ||
    !user.withdrawal_bank_name
  ) {
    withdrawalDisplay = (
      <div>
        <p>
          You need to add the bank account details you wish to withdraw to in
          order to request for a withdrawal
        </p>

        <p className="mt-1">
          Please add a bank account in the Payment Tab under{" "}
          <Link to="/dashboard/account" className="text-primary font-bold">
            Account Settings
          </Link>
        </p>
      </div>
    );
  }

  return (
    <>
      <div
        className={`relative rounded-xl bg-blue-600 px-3 pt-2 pb-4 lg:pt-4`}
        style={{
          backgroundImage: `url(${user?.meta_data?.balance_background || bg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundColor: "#000000aa",
          backgroundBlendMode: "multiply",
        }}
      >
        <div className="shadow-chart flex w-full flex-col items-start text-white lg:flex-row lg:justify-between lg:gap-4 dark:border-none">
          <div className="flex items-center gap-2">
            <div className="flex flex-1 items-start">
              <div className="flex flex-1 flex-col gap-3">
                <div className="mb-2 flex cursor-pointer items-center gap-2 lg:mb-0">
                  <h2 className="text text-lg font-semibold lg:text-lg">
                    Wallet Balance
                  </h2>
                </div>
              </div>
            </div>
          </div>

          <div className="flex gap-2">
            <button
              className="text-primary flex cursor-pointer items-center gap-x-1 rounded-lg bg-white px-3 py-2 font-medium"
              onClick={() => navigate("/dashboard/fund-wallet")}
            >
              <FaPlus size={10} />
              <h2 className="text-xs font-medium lg:text-sm">Add Money</h2>
            </button>
            <button
              className="text-primary flex items-center gap-x-1 rounded-lg bg-white px-3 py-2 font-medium"
              onClick={() => {
                if (user.pendingWithdrawal) {
                  return Report.warning(
                    "Existing Withdrawal in Progress",
                    `You have a pending withdrawal request of ₦${formatter.format(user.pendingWithdrawal.amount)}. Please wait until it has been settled`,
                  );
                }
                setWithdrawOpen(true);
              }}
            >
              <MdDownload size={15} />
              <h2 className="text-xs font-medium lg:text-sm">
                Withdraw Commission
              </h2>
            </button>
          </div>
        </div>

        <div className="flex gap-2 pt-10 text-white">
          <div className="p-2">
            <p className="text-xs font-semibold text-white lg:text-sm">
              Total Current Balance
            </p>

            <div className="flex items-center pt-1">
              {/* <TbCurrencyNaira size={30} /> */}
              <h1 className="text-2xl font-bold lg:text-3xl">
                {/* ₦ 537,000 */}₦{" "}
                {hidden ? "******" : formatter.format(user.account_balance)}
              </h1>
            </div>
          </div>
          <div className="block flex-1 lg:hidden"></div>
          <div className="rounded-lg bg-white/20 p-2 pr-10">
            <p className="text-xs font-semibold text-white lg:text-sm">
              Commission Balance
            </p>
            <div className="flex items-center pt-1">
              {/* <TbCurrencyNaira size={30} /> */}
              <h1 className="text-2xl font-bold lg:text-3xl">
                ₦ {hidden ? "******" : formatter.format(user.commission)}
                {/* {formatter.format(43000)} */}
              </h1>
            </div>
          </div>
        </div>

        {/* User Tags */}

        <span className="absolute top-0 right-0 size-fit rounded-none rounded-tr-xl rounded-br-none rounded-bl-lg bg-slate-900 p-1 px-3 text-sm font-semibold text-white lg:top-auto lg:right-0 lg:bottom-0 lg:rounded-tl-lg lg:rounded-tr-none lg:rounded-br-xl lg:rounded-bl-none">
          Billzpay {isAgent ? "Agent" : "User"}
        </span>
      </div>

      <Dialog open={addMoney} onOpenChange={setAddMoney}>
        <DialogContent className="font-jakarta dark:bg-darkBg w-[900px] max-w-[95vw] border-none">
          <DialogHeader>
            <DialogTitle className={"text-darkInput dark:text-white"}>
              Fund Wallet
            </DialogTitle>
            <DialogDescription>
              Add money either via bank transfer to virtual account or via
              instant payment
            </DialogDescription>
          </DialogHeader>
          <div className="grid grid-cols-2 gap-4">
            <div className="dark:bg-darkInput col-span-2 flex flex-col justify-between rounded-lg bg-gray-100 p-5 lg:col-span-1">
              <h2 className="pb-3 text-xl font-bold text-gray-900 dark:text-white">
                Instant Payment
              </h2>

              <DialogDescription>
                Open instant payment portal and recieve multiple options to
                quicky and securely fund your wallet
              </DialogDescription>

              <form onSubmit={initializeTransaction} className="pt-3">
                <div className="dark:border-darkBorder dark:bg-darkInput mt-1 flex items-center gap-x-3 rounded-md border bg-gray-100 p-2 py-2.5">
                  <CurrencyInput
                    name="amount"
                    placeholder="Input amount (₦)"
                    value={amount}
                    onValueChange={(e) => setAmount(e)}
                    className="w-full border-none bg-transparent text-sm outline-none dark:text-white"
                    required
                    prefix="₦ "
                  />
                </div>

                <button
                  className={`bg-primary mt-3 w-full rounded-md p-2 font-medium text-white ${loading && "opacity-65"}`}
                  disabled={loading}
                  type="submit"
                >
                  {loading ? "Processing..." : "Proceed"}
                </button>
              </form>
            </div>

            <div className="dark:bg-darkInput col-span-2 flex flex-col justify-between rounded-lg bg-gray-100 p-5 lg:col-span-1">
              <h2 className="text-xl font-bold dark:text-white">
                Virtual Account Number
              </h2>

              {hasAccount ? (
                <>
                  <DialogDescription>
                    <div className="flex pt-3">
                      <span>Account Number</span>
                      <div className="flex-1"></div>
                      <b>23423432432</b>
                    </div>
                    <div className="flex py-3">
                      <span>Account Name</span>
                      <div className="flex-1"></div>
                      <b>John Doe</b>
                    </div>
                    <div className="flex pb-3">
                      <span>Bank Name</span>
                      <div className="flex-1"></div>
                      <b>Paystack Titan</b>
                    </div>
                  </DialogDescription>
                  <button
                    className={`bg-primary w-full rounded-md p-2 text-white`}
                  >
                    Copy Account Number
                  </button>
                </>
              ) : (
                <>
                  <DialogDescription className="text-center">
                    You dont have a dedicated virtual account number yet
                  </DialogDescription>
                  <form onSubmit={requestAccount}>
                    <button
                      className={`bg-primary w-full rounded-md p-2 font-semibold text-white`}
                      onClick={() =>
                        toast.warning(
                          "This Feature is not yet available, Stay tuned!",
                        )
                      }
                    >
                      Request Account Number
                    </button>
                  </form>
                </>
              )}
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <Dialog open={withdrawOpen} onOpenChange={setWithdrawOpen}>
        <DialogContent className="font-jakarta dark:bg-darkBg border-none">
          <DialogHeader>
            <DialogTitle
              className={"text-darkInput text-start dark:text-white"}
            >
              Commission Withdrawal Request
            </DialogTitle>
            <DialogDescription className="text-start text-xs">
              Withdraw your commission to your preferred bank account
            </DialogDescription>
          </DialogHeader>
          <div className="text-sm text-black dark:text-white">
            {withdrawalDisplay}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default TotalBalanceBox;
